import $ from 'jquery';
import React,{ useState,useEffect } from 'react';

import pdfIcon from '../assets/images/pdf_icon.png';
import mp3Icon from '../assets/images/mp3_icon.png';
import mp4Icon from '../assets/images/mp4_icon.png';


let tmpObjImages=[];

let objImages = [];
let indexExisting=0;
let arrExistingFiles=[];
let totalFileAllow=20;
// related to image upload sc

      //  check file validation
export function  fileValidation_V1(){
        let allowFile=true;
     let imgCount=objImages.length;
     let vTotalCount=imgCount
    
     if(vTotalCount>=totalFileAllow){
      alert("Only "+totalFileAllow+" to be allowed .");
      allowFile=false;
     }
     return allowFile;
 }
 //  check file validation  

export function rmFileProc_V1(data,lsImages,thumbDiv){
    //alert("i m in in remove file "+lsImages);
    if(lsImages==="" || lsImages==="0"){
      lsImages="lsImages"
    }
    if(thumbDiv==="" || thumbDiv==="0"){
      thumbDiv="ref_div_";
    }
    
    if(document.getElementById(thumbDiv+data)!=null){
      document.getElementById(thumbDiv+data).remove();
    }
    
    this.lcRemoveJSON(data,"image",lsImages,thumbDiv);
}
  

export function lcRemoveJSON_V1(refKey,fType,lsImages,thumbDiv){
    var jsonP=JSON.parse($("#"+lsImages).val());
    var arrJson=jsonP.objs;
    for(var ai=0;ai<arrJson.length;ai++){
      if(arrJson[ai]["name"]===refKey){
        arrJson.splice(ai,1);
        $("#"+lsImages).val(JSON.stringify(jsonP));
        break;
      }
    }
    objImages=arrJson;
  }

export function  ImageThumbBackNew_V1(flImg, flName,fObject,othInfo="",lsElement="",thumbnail="",isMultiple=true)
  {
   
       
        if(!fileValidation_V1()){
          return;
        }
      
        if(flImg==="-10"){
          alert(flName);
          return;
        }
        if(lsElement===""){
          lsElement="lsImages"
        }
        let currentObject=null;
        let thumDiv="ref_div_";
        if(fObject){
          currentObject=fObject[0];
          if(currentObject.hasAttribute("thumbnail_div")){
            thumDiv=currentObject.getAttribute("thumbnail_div");
          }
      
        }
      
        if(othInfo===""){
          othInfo="nm"+indexExisting+","+indexExisting;
        }
        indexExisting++;
        let name_for= fObject.attr("id");
        var arrNmValue=othInfo.split(',');
        //arrExistingFiles.push
        arrExistingFiles[arrNmValue[1]]=arrNmValue[0];
        var strSet = "<div id=\""+thumDiv+arrNmValue[1]+"\" class=\"col-lg-3 col-md-3 col-sm-3 col-6 lsthumb image_thumb_parent\">" +
        "<i class=\"fa fa-close icon-close _removeBtn"+indexExisting+"\" param3=\""+thumDiv+"\" param2=\""+lsElement+"\" param1=\""+arrNmValue[1]+"\" aria-hidden=\"true\"></i>"+
          "<a class=\"gallery-item\" href=\""+flImg+"\"><img src=\"" + flImg + "\"/></a>" +
          "</div>";
          if(flImg.indexOf("data:video/webm")!==-1 || flImg.indexOf("data:video/mp4")!==-1){
           strSet= "<div id=\""+thumDiv+arrNmValue[1]+"\" class=\"col-lg-3 col-md-3 col-sm-3 col-12 lsthumb image_thumb_parent\">" +
            "<i class=\"fa fa-close icon-close _removeBtn"+indexExisting+"\"  param3=\""+thumDiv+"\" param2=\""+lsElement+"\" param1=\""+arrNmValue[1]+"\" aria-hidden=\"true\"></i>"+
              "<a class=\"gallery-item\" href=\""+flImg+"\"><video controls type=\"video/mp4\" src=\"" + flImg + "\"/></a>" +
              "</div>";
          }else if(flImg.indexOf("data:application/pdf")!==-1 || flImg.indexOf("data:application/pdf")!==-1){
            strSet= "<div id=\""+thumDiv+arrNmValue[1]+"\" class=\"col-lg-2 col-md-2 col-sm-2 col-12 lsthumb image_thumb_parent\">" +
            "<i class=\"fa fa-close icon-close _removeBtn"+indexExisting+"\"  param3=\""+thumDiv+"\" param2=\""+lsElement+"\" param1=\""+arrNmValue[1]+"\" aria-hidden=\"true\"></i>"+
              "<a class=\"gallery-item\" href=\""+flImg+"\"><img src="+pdfIcon+" /></a>" +
              "</div>";
          }
      
        
      
      
          
        //$("#audios").val("{\"objs\":" + JSON.stringify(objAudio) + "}");
        
       // alert(objImages.length);
      
       
       if($("#"+lsElement).val()!==""){
        if(isMultiple===true){
          //alert("i min multiple");
          tmpObjImages=JSON.parse($("#"+lsElement).val());
          tmpObjImages=tmpObjImages.objs;
        }
       }
       tmpObjImages.push({ name_for:name_for,name: arrNmValue[1], value: flImg });
       //tmpObjImages.push({ name_for:name_for,name: arrNmValue[1], value: "test" });
       $("#"+lsElement).val("{\"objs\":" + JSON.stringify(tmpObjImages) + "}");
        
        //alert(tmpObjImages.length);
        //alert(strSet);
      if(thumbnail===""){
        thumbnail="imgLibThumb";
      }
      //alert(thumbnail);
      if(isMultiple===false){
        $("."+thumbnail).html(strSet);
      }else{
        //alert("i m in append");
        $("."+thumbnail).append(strSet);
      }
      
        
        
        if(fObject!==null){
          fObject.val('');
        }
   
      //RespBkMthdMapp(this, "_removeBtn"+indexExisting, "rmFileProc", "2");
   //uncomment above once  done all
}

export const FileUploaderV1=(htCls,cBack)=>{
  
    $("._brFileThumb").unbind('click');
    $(".updImgThumb").unbind('change');
    
    $("._brFileThumb").click(function(){
      var getNm=$(this).attr("setTo");
      //alert("i am  in click of"+getNm);
      document.getElementById(getNm).click();
    });
    
    $(".updImgThumb").change(function(){
      var currentObj=$(this);
      var refBack=$(this).attr("ref_img");
      var refFlName=this.value.split('\\').pop();
    
      let isMultiple=false;
      let checkMultiple=$(this).attr("multiple");
      //alert(checkMultiple);
      if(typeof checkMultiple!=="undefined"){
        
        isMultiple=true;
      }
    
    
      let checkSize=$(this).attr("size");
      //alert();
      //alert(refBack);
      if (this.files && this.files[0]) {
        //alert(this.files[0].size);
        //check size
        if (typeof checkSize !== 'undefined' && checkSize !== false) {
          if(this.files[0].size>checkSize){
            return cBack("-10","Size larger then validated!",currentObj);
          }
      }
    
      let jvThis=$(this)[0];
      
      let thumbnail="";
      if(jvThis.hasAttribute("thumbnail")){
        thumbnail=jvThis.getAttribute("thumbnail");
      }
      //alert(thumbnail+" = "+refBack)
    
      let lsElement="";
      if(jvThis.hasAttribute("lsElement")){
        lsElement=jvThis.getAttribute("lsElement");
      }
    
    
        
        //alert("i am read url");
          var reader = new FileReader();
          reader.onload = function (e) {
            //var refBack=$(this).attr("ref_img");
            //alert(refBack);
            //alert(e.target.name);
            return ImageThumbBackNew_V1(e.target.result,refFlName,currentObj,"",lsElement,thumbnail,isMultiple);
            //alert($(input).attr("ref_img"));
             // $('.'+$(input).attr("ref_img")).attr('src', e.target.result);
          }
    
          reader.readAsDataURL(this.files[0]);
      }
    });
    }

export default FileUploaderV1;